import { ArslActionSetVariableFilter, ArsListingState } from "../interface";

/**
 * Updates the listing variable sidebar filter text.
 *
 * @param state - Current ARS listing state
 * @param action - Set-variable-filter action containing the filter text
 * @returns Updated ARS listing state with the new filter text
 */
export const arsl_setVariableFilter = <T>(
  state: ArsListingState<T>,
  action: ArslActionSetVariableFilter,
): ArsListingState<T> => ({
  ...state,
  settings: {
    ...state.settings,
    variableFilter: action.variableFilter,
  },
});
